import ProductItem from './ProductItem';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';

const ProductItemsBox = ({ title, data }) => (
    <div className="box product-box">
        <h3>{title}</h3>
        <div className="product-items">
            {data.map(product => (
                <ProductItem key={product.name} product={product} />
            ))}
        </div>
        <Button type="show-more">SHOW MORE</Button>
    </div>
);

export default ProductItemsBox;
